import Gradient from 'chartjs-plugin-gradient';
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    BarController,
    BarElement,
    Title,
    Tooltip,
    Legend,
    Filler
} from 'chart.js';
import { Bar } from 'react-chartjs-2';
import {  prepareDatasetForStackedBarChart } from '../../common/graphHelper';


// Note: changes to the plugin code is not reflected to the chart, because the plugin is loaded at chart construction time and editor changes only trigger an chart.update().
const image = new Image();
image.src = 'https://www.chartjs.org/img/chartjs-logo.svg';



ChartJS.register(
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    BarController,
    BarElement,
    Title,
    Tooltip,
    Filler,
    Legend, Gradient);

const _props = {
    labels: [],
    datasets: [],
    data:[],
    totalDatasets: 0,
    graphConfig:{},
    dataListTemplate:'',
    period:'',
    clickFilter:()=>{}
}



export function StackedBarChart(props = _props) {

    const data =prepareDatasetForStackedBarChart(props.data,props.graphConfig.colorPalette,props.graphConfig.dataPoint,props.period);

    return  <div className='row align-item-center mt-3 bar-chart'>
    <div className='col-md-12'>  
        <Bar options={{
            plugins: {
              legend: {
                position: 'bottom',
                labels: {
                    boxWidth: 22,
                    boxHeight: 4
                },
                onHover:(e)=>{
                    e.native.target.style.cursor = 'pointer';
                },
                onLeave:(e)=>{
                    e.native.target.style.cursor = 'default';
                },
              },
              datalabels: {
                borderColor: 'white',
                borderRadius: 25,
                borderWidth: 0,
                color: 'white',
                display: function (context) {
                    var dataset = context.dataset;
                    var value = dataset.data[context.dataIndex];
                    return value > 5;
                },
                font: {
                    weight: 'bold',
                    size:'10',
                },
                padding: 2,
                formatter: (val,context) => {
                    const datasetArray=[];
                    context.chart.data.datasets.forEach((dataset)=>{
                      if(dataset.data[context.dataIndex] != undefined){
                        datasetArray.push(dataset.data[context.dataIndex]);
                      }
                    })
                    function totalSum(total,dataPoint){
                      return total+dataPoint;
                    }
                    let sum = datasetArray.reduce(totalSum,0);
                    return ((val/sum)*100).toFixed(0)+'%';
                }
              }
            },
            onHover:(e,activeEls)=>{
              e.native.target.style.cursor = activeEls[0] ? 'pointer':'';
            },
            onClick: (e, activeEls) => {
              props.clickFilter(e, activeEls, data);
            },
            scales: {
              x: {
                  stacked:true,
                  grid: {
                      display: false
                  },
                  offset: true
              },
              y: {
                  stacked:true,
                  grid: {
                      borderDash: [4],
                      display: true,
                      drawTicks:false,
                      lineWidth:[1.3]
                  }
              }
            },
            // Core options
            responsive: true,
            aspectRatio: 8 / 3.6,
            layout: {
                padding: 6
            },
            
            
        }

        }
       
         data={data} />
         </div>
      </div>


        
    
   
    
        
    
}
